// @flow

import * as React from 'react'

export const Google = () => {
  return (
    <svg width="28px" height="28px" viewBox="0 0 20 20" version="1.1">
      <g
        id="_Icons/google"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="icons/google" transform="translate(1.900000, 1.900000)">
          <path
            d="M15.976,8.38409091 C15.976,7.80972727 15.9244545,7.25745455 15.8287273,6.72727273 L8.2,6.72727273 L8.2,9.8605 L12.5592727,9.8605 C12.3715,10.873 11.8008182,11.7308636 10.9429545,12.3052273 L10.9429545,14.3375909 L13.5607273,14.3375909 C15.0923636,12.9274545 15.976,10.8509091 15.976,8.38409091 L15.976,8.38409091 Z"
            id="Shape"
            fill="#4285F4"
          ></path>
          <path
            d="M8.2,16.3 C10.387,16.3 12.2205455,15.5746818 13.5607273,14.3375909 L10.9429545,12.3052273 C10.2176364,12.7912273 9.28981818,13.0784091 8.2,13.0784091 C6.09031818,13.0784091 4.30463636,11.6535455 3.66768182,9.739 L0.961545455,9.739 L0.961545455,11.8376364 C2.29436364,14.4848636 5.03363636,16.3 8.2,16.3 L8.2,16.3 Z"
            id="Shape"
            fill="#34A853"
          ></path>
          <path
            d="M3.66768182,9.739 C3.50568182,9.253 3.41363636,8.73386364 3.41363636,8.2 C3.41363636,7.66613636 3.50568182,7.147 3.66768182,6.661 L3.66768182,4.56236364 L0.961545455,4.56236364 C0.412954545,5.65586364 0.1,6.89295455 0.1,8.2 C0.1,9.50704545 0.412954545,10.7441364 0.961545455,11.8376364 L3.66768182,9.739 L3.66768182,9.739 Z"
            id="Shape"
            fill="#FBBC05"
          ></path>
          <path
            d="M8.2,3.32159091 C9.38922727,3.32159091 10.4569545,3.73027273 11.2964091,4.53290909 L13.6196364,2.20968182 C12.2168636,0.902636364 10.3833182,0.1 8.2,0.1 C5.03363636,0.1 2.29436364,1.91513636 0.961545455,4.56236364 L3.66768182,6.661 C4.30463636,4.74645455 6.09031818,3.32159091 8.2,3.32159091 L8.2,3.32159091 Z"
            id="Shape"
            fill="#EA4335"
          ></path>
          <polygon
            id="Shape"
            points="0.1 0.1 16.3 0.1 16.3 16.3 0.1 16.3"
          ></polygon>
        </g>
      </g>
    </svg>
  )
}
